import get from 'lodash/get';
import {
  FETCH_SHIPMENTS_DETAILS,
  FETCH_SHIPMENTS_DETAILS_FAILURE,
  FETCH_SHIPMENTS_DETAILS_SUCCESS,
} from './types';

const initialState = {
  isShipmentsLoading: false,
};

const ShipmentDashBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIPMENTS_DETAILS: {
      return {
        ...state,
        isShipmentsLoading: true,
      };
    }

    case FETCH_SHIPMENTS_DETAILS_SUCCESS: {
      const resData = get(action, 'response', []);
      resData.rows.sort(function (a, b) {
        return b.id - a.id;
      });
      resData.rows.map((item, i) => {
        item.sno = i + 1;
      });
      return {
        ...state,
        shipmentListData: resData.rows,
        shipmentsCount: resData.count,
        isShipmentsLoading: false,
      };
    }

    case FETCH_SHIPMENTS_DETAILS_FAILURE: {
      return {
        ...state,
        isShipmentsLoading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default ShipmentDashBoardReducer;
